import React from 'react';
import styled from 'styled-components';

import { RegularText } from '@/styles/typography';

export const SimpleCard = ({ title, description, icon }) => {
  const Icon = icon;
  return (
    <Wrapper>
      <WrapperInner>
        <Icon />
      </WrapperInner>

      <WrapperInner>
        <Title>{title}</Title>
        <RegularText>{description}</RegularText>
      </WrapperInner>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  width: 100%;
  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 20px;
  flex: 1 0 0;
  border-radius: 10px;
  border: 1px solid #dbe0ef;
`;

const WrapperInner = styled.div``;

const Title = styled.h4`
  color: #192d52;
  font-family: var(--font-roboto);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
